import Header from 'components/organisms/Header';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators, getCurrentViewID, getHeaderTitle } from 'store/view';

const mapStateToProps = (state, ownProps) => ({
	title: getHeaderTitle(state, ownProps.dayNumber),
	currentViewId: getCurrentViewID(state),
});

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(actionCreators, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Header as any);
